<template>
  <div class="indexPage" :class="showCertification?'certification' : ''">
    <van-popup  :close-on-click-overlay="false"  overlay :overlay-style="{ backgroundColor: 'rgba(0, 0, 0, 0.3)' }" v-model="showCertification" round position="center" :style="{ width: '95%' }" >
        <div class="certification-box">
            <p class="certification-title">人脸识别认证</p>
            <div class="certification-text">
                <p>
                     根据《国家税务总局关于互联网平台企业为平台内从业人员办理扣缴申报、代办申报若干事项的公告》政策要求，为确认为您本人操作，我们需要进行人脸识别。
                </p>
                <ul>
                    <li>我们仅收集必要的特征信息用于本次验证。</li>
                    <li>信息将进行加密处理，并严格遵循隐私政策。</li>
                </ul>
            </div>
            <div class="certification-btn-box-btn"> 
                
                <van-button
                type="primary"
                class="certification-btn"
                 @click="certification"
                >同意并验证</van-button
                >
            </div>
              
        </div>
    </van-popup>
    <van-sticky>
      <van-row class="p-header">
        <van-col span="4" class="title">首页</van-col>
        <van-col span="17" class="search">
          <van-search
            shape="round"
            v-model="taskName"
            placeholder="请输入搜索关键词"
            @search="onSearch"
          />
        </van-col>
        <van-col
          span="3"
          class="icon"
          @click="$router.push({ path: '/news', query: { tab: 2 } })"
        >
          <van-icon name="bell" :badge="unReadMessage" />
        </van-col>
      </van-row>
    </van-sticky>
    <div class="banner">
      <van-image v-if="bannerDefault" :src="banner" fit="cover" />
      <van-swipe v-else :autoplay="3000" indicator-color="white">
        <van-swipe-item
          v-for="(banner, index) in indexBannerArray"
          :key="index"
        >
          <van-image
            :src="iconPath + banner.pic"
            @click="toPoster(banner)"
            fit="cover"
          />
        </van-swipe-item>
      </van-swipe>
    </div>

    <van-row class="modules">
      <van-col span="6" v-for="(item, index) in modules" :key="index">
        <router-link :to="item.path" class="item">
          <van-image
            width="1.44rem"
            height="1.44rem"
            fit="contain"
            :src="item.icon"
          />
          <p>{{ item.text }}</p>
        </router-link>
      </van-col>
    </van-row>

    <div class="main-section">
      <div class="list" :gutter="12" v-if="taskList.length">
        <van-cell class="header" value="更多" is-link to="/tasksList">
          <template #title> <van-icon name="fire" />热门任务 </template>
        </van-cell>
        <a
          href="javascript:void(0);"
          v-for="(item, index) in taskList"
          @click="handleDetail(item)"
          :key="'taskItem' + index"
          class="index_task_item"
        >
          <div class="title">
            <div class="price">
              {{ item.taskMoney == "费用面议" ? "" : item.amount }}
              <span
                :class="{
                  only:
                    item.amount == undefined ||
                    item.amount.length == 0 ||
                    item.taskMoney == '费用面议',
                }"
              >
                <template v-if="item.taskMoney == '费用面议'"
                  >费用面议</template
                >
                <template v-else-if="item.taskMoney == '固定价格'"
                  >/元</template
                >
                <template v-else-if="item.taskMoney == '按月'">元/月</template>
                <template v-else-if="item.taskMoney == '按周'">元/周</template>
                <template v-else-if="item.taskMoney == '按天'">元/天</template>
                <template v-else-if="item.taskMoney == '按时'"
                  >元/小时</template
                >
              </span>
            </div>
            <span class="hot" v-if="index < 3">热</span>
            <span class="name">{{ item.ecompanyJobCategoryName }}</span>
          </div>
          <div class="desc" v-html="item.taskName"></div>
          <div class="city">
            <span class="time">发布时间:{{ sliceData(item.publishDate) }}</span>
            地点:{{ item.cityName ? item.cityName : "不限" }}
          </div>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Sticky,
  Row,
  Col,
  Search,
  Icon,
  Image,
  Cell,
  Swipe,
  SwipeItem,
  Notify,
  Button,
  Toast,
  Popup
} from "vant";
import api from "@/api/list";
import { getToken } from "@/utils/auth";
import { browserUA } from '@/utils/browserUA'
import { mapGetters,mapMutations } from "vuex";
export default {
  components: {
    [Sticky.name]: Sticky,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Search.name]: Search,
    [Image.name]: Image,
    [Cell.name]: Cell,
    [SwipeItem.name]: SwipeItem,
    [Swipe.name]: Swipe,
    [Notify.name]: Notify,
    [Toast.name]: Toast,
    [Button.name]: Button,
    [Popup.name]: Popup
  },
    computed: {
    ...mapGetters([
      "userInfo"
    ]),
  },
  data() {
    return {
      iconPath: process.env.VUE_APP_FILE_PATH,
      showCertification:false,
      banner: require("./assets/banner.png"),
      bannerDefault: true,
      indexBannerArray: [],
      indexPosetAreaCode: "index",
      taskList: [],
      token:getToken(),
      taskName: "",
      unReadMessage: 0,
      modules: [
        {
          id: 0,
          icon: require("./assets/icon_task.png"),
          text: "我的任务",
          path: "/myTasksList",
        },
        {
          id: 1,
          icon: require("./assets/icon_contract.png"),
          text: "我的协议",
          path: "/contractList",
        },
        {
          id: 3,
          icon: require("./assets/icon_help.png"),
          text: "帮助中心",
          path: "/news",
        },
      ],
    };
  },
 async created() {
  this.hasFaceVedio();
   let userId = await  this.getActiveUserAllInfoInit();
   if(userId.toString() !== "5257" && userId.toString() !== ""){
    let obj =   {
          id: 2,
          icon: require("./assets/icon_bank.png"),
          text: "我的收款账号",
          path: "/card",
        };
     this.modules.splice(2,0,obj);
   }

    
    //获取任务列表
    api.hotTaskList().then((res) => {
      if (res.data.status == "200") {
        this.taskList = res.data.data;
      }
    });

    if (getToken()) {
      //获取未读消息条数
      api.unReadMessage().then((res) => {
        if (res.data.status == "200" && res.data.data) {
          this.unReadMessage = res.data.data;
        }
      });
    }
    if( this.$store.getters.mobileBanner!=null&&this.$store.getters.mobileBanner&&this.$store.getters.mobileBanner.length>0){ //企业个性化
            this.banner = this.$store.getters.mobileBanner;
    }else{
        //广告位
        this.initPoster();
    }

  },
  methods: {
    hasFaceVedio(){
        api.hasFaceVedio().then(res=>{
          if(res.status=="200" && res.data.toString()==='0'){
            this.showCertification = true
          }else{
            this.showCertification = false
          }
        })  
    },
    //去认证
    certification(){
        api.individualFace({},{ method: "post" }).then((res) => {
              if (res.status == '200') {
                let json = JSON.parse(res.data.data)
                if (json == null) {
                  Toast.fail(res.data.message)
                } else {
                  browserUA().then((browserType) => {
                    if (browserType == 'androidAPP') {
                      window.VpShopJs.bodyCheck(
                        JSON.stringify({ url: json.url })
                      )
                    } else {
                      location.href = json.url
                    }
                  })
                this.showCertification = false
                }
               
              } else {
                Toast.fail('发起认证失败')
              }
            })
    },
    getActiveUserAllInfoInit(){
      return new Promise((resolve, reject) => {
        if(this.userInfo&&this.userInfo.id){
             resolve(this.userInfo.id);
        }else{ 
            if (getToken()) { 
                api.getActiveUserAllInfo().then((res) => {
                    if (res.data.status == "200") {
                    let user = res.data.data;
                    this.$store.commit('SET_USER_INFO', user)
                    resolve(user.id);
                    }
                }).catch(error => {
                    reject(error);
                });
            } else{
                resolve("");
            }
        }
  
      })
    },
    onSearch() {
      this.$router.push({
        path: "/tasksList",
        query: {
          taskName: this.taskName,
        },
      });
    },
    initPoster() {
      if(getToken()){
        //debugger
        api
          .contentPosterlistToActiveUser({}, { subUrl: this.indexPosetAreaCode })
          .then((res) => {
          if (res.data.status == "200") {
            if (
              res.data.data &&
              typeof res.data.data != "undefined" &&
              res.data.data.length > 0
            ) {
              this.indexBannerArray = res.data.data;
              this.bannerDefault =
                this.indexBannerArray.length > 0 ? false : true;
            }
          } else {
            this.$notify({
              message: res.data.message,
              type: "danger",
              duration: 2000,
            });
          }
        });
      }else{
        api
          .contentPosterlistToNoLoginUser({}, { subUrl: this.indexPosetAreaCode })
          .then((res) => {
          if (res.data.status == "200") {
            if (
              res.data.data &&
              typeof res.data.data != "undefined" &&
              res.data.data.length > 0
            ) {
              this.indexBannerArray = res.data.data;
              this.bannerDefault =
                  this.indexBannerArray.length > 0 ? false : true;
            }
          } else {
            this.$notify({
              message: res.data.message,
              type: "danger",
              duration: 2000,
            });
          }
        });
      }
    },
    toPoster(item) {
      if (item.url == undefined) {
        return false;
      } else if (
        item.url &&
        (item.url.startsWith("http://") || item.url.startsWith("https://"))
      ) {
        window.open(item.url);
      } else {
        this.$router.push(item.url);
      }
    },
    handleDetail(item) {
      if (item.isApply) {
        this.$router.push({ path: "/myTasksDetail", query: { id: item.id } });
      } else {
        this.$router.push({ path: "/tasksDetail", query: { id: item.id } });
      }
    },
    sliceData(data) {
      if (data && data.length == 10) {
        return data.slice(5);
      }
    },
    ...mapMutations(['SET_USER_INFO'])
  },
};
</script>

<style lang="less" scoped>
.certification-box{
    font-size: 14px;
    color: #333;
    padding: 0 6px;
    .certification-title{
        font-weight: bold;
        text-align: center;
        height: 40px;
        line-height: 40px;
    }
    .certification-text{
        line-height: 22px;
        p{
            text-indent: 2em;
        }
        ul{
            li{
                position: relative;
                padding-left: 36px;
                margin: 2px 0;
                list-style: none !important;
                &::before {
                content: '•';
                position: absolute;
                left: 25px;
                top: 2px;
                color: #333;
                font-size: 16px;
                line-height: 22px;
                }
            }
        }
        
    }
    .certification-btn-box-btn{
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 12px 30px;
    }
    .certification-cancel{
         width: 100px;
        border-color:  #666;
        color: #333;
        margin-right: 12px;
    }
    .certification-btn{
      width: 120px;
      background: #6c7ef3;
      border-color:  #6c7ef3;
      border-radius: 4px;  
    }
}
.certification{
  /deep/.van-overlay{
    display: block!important;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.3);
  }
}
.indexPage {
  margin: -46px 0 10px;

  .p-header {
    background: #fff;
    line-height: 46px;
    text-align: center;
    .title {
      font-size: 18px;
      font-weight: 600;
    }

    .search {
      .van-search {
        padding: 6px 0;
      }
    }

    .icon {
      position: relative;
      font-size: 24px;
      color: #6275f0;
      top: 2px;
      .van-info {
        top: 6px;
        right: 2px;
      }
    }
  }

  .main-section {
    padding: 0 8px;

    .header {
      padding: 10px;
      font-weight: 600;
      border-radius: 4px;
      .van-icon-fire {
        display: inline-block;
        vertical-align: middle;
        margin-top: -3px;
        margin-right: 3px;
        color: #f06262;
        font-size: 18px;
      }

      .van-cell__value {
        margin-right: -6px;
        font-weight: 400;
      }
    }

    .list {
      .index_task_item {
        display: block;
        background: #fff;
        margin-top: 2px;
        border-radius: 4px;
        padding: 16px;
        color: #666;
        font-size: 12px;
        line-height: 24px;

        &:active {
          background: #dadef9;
        }

        & > div {
          height: 24px;
        }

        .title {
          font-size: 14px;
          color: #333;
          font-weight: 600;
          margin-bottom: 2px;
          .hot {
            background: #f06262;
            color: #fff;
            font-size: 11px;
            padding: 0 2px;
            margin-right: 3px;
            line-height: 16px;
            border-radius: 2px;
            margin-top: -3px;
            vertical-align: middle;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
          }
          .price {
            float: right;
            color: #f3852c;
            font-size: 14px;
            span {
              font-size: 10px;
              margin-left: -2px;
              &.only {
                font-size: 14px;
              }
            }
          }
        }

        .city {
          font-size: 10px;
          color: #999;
          margin-top: 6px;
          .time {
            float: right;
          }
        }
      }
    }
  }
}
.banner {
  display: block;
  margin: 8px;
  border-radius: 0.12rem;
  overflow: hidden;
  box-shadow: 0 0 0.32rem rgba(0, 0, 0, 0.05);

  .van-image {
    display: block;
    width: 100%;
    height: 156px;
    border-radius: 0.12rem;
    overflow: hidden;
  }
}

.modules {
  .item {
    display: block;
    padding: 0.32rem 0 0.5rem;
    text-align: center;
    p {
      color: #999;
      font-size: 0.2933rem;
      margin-top: -0.08rem;
    }
  }
}
</style>


